// @ts-nocheck
import React, { useEffect, useMemo, useState } from "react";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";
import { ConfirmationPageTemplate } from "@/templates/ondemand/signup/confirmation/confirmation-page/src";
import { useGupsStatus } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks";

import { getFeatureFlagValues } from "../../../../wac-routes";

export type ConfirmationPageProps = {
    availableProducts: AvailableProductsResponse | null;
};

export const ConfirmationPage = ({
    availableProducts
}: ConfirmationPageProps) => {
    const { getProfileCallback } = useGupsStatus();
    const [subAnchor, setSubAnchor] = useState();

    useEffect(() => {
        const getData = async () => {
            const result = await getProfileCallback();
            if (result?.error) {
                console.log(`gups profile error ${result.error}`);
            }
            if (result?.data) {
                const { data } = result;
                setSubAnchor(data?.paidChannelContext?.confluence?.subAnchor);
            }
        };
        getData();
    }, [getProfileCallback]);
    return (
        <ConfirmationPageTemplate
            featureFlags={
                window.featureFlags ||
                getFeatureFlagValues(window.location.search.split("&"))
            }
            isProduction={process.env["CLIENT_LIBRARY_ENV"] === "production"}
            subAnchor={subAnchor}
            availableProducts={availableProducts}
        />
    );
};
